import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  Typography,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import instance from "../../../axios";
import moment from "moment";
import PaymentSummary from "./PaymentSummaryCard";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ConfirmDialoag from "../../common/ConfirmDialoag";
import { callActiveInactiveCron } from "../../../Helpers";

const ListPaymentDetails = ({ open, onClose, selectedPaymentItem,getPaymentsData}) => {
  const [visibleCount, setVisibleCount] = useState(6);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);


  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 3);
  };
  const [invoicePayments, setInvoicePayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAllocatedConfirm, setIsAllocatedConfirm] = useState(false);


 const fetchInvoicePayments = async () => {
    if (!selectedPaymentItem) return;
    setLoading(true);
    try {
      const data = await instance.get(
        `/api/invoicepayments/${selectedPaymentItem.id}`
      );
      setInvoicePayments(data || []);
    } catch (error) {
      console.error("Error fetching invoice payments:", error);
      toast.error("Failed to load payments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoicePayments();
  }, [selectedPaymentItem]);

  const showSelectedPayment=(item)=>{
    setSelectedPaymentId(item)
    setIsAllocatedConfirm(true)

  }

  
    const updateInvoicePayment = async () => {
      if(!selectedPaymentId) return;
      try {
        const data = await instance.put(
          `/api/invoicepayments/processpiip/${selectedPaymentId.id}`
        );
            const cn = selectedPaymentItem?.contractNumber;
                      if (cn && typeof cn === "string" && cn.trim() !== "") {
                        callActiveInactiveCron(cn);
                      }
    fetchInvoicePayments();
    getPaymentsData()
        toast.success(data||" Processed Successfully")
      } catch (error) {
        toast.error(error?.message||"Something went wrong")
      } finally {
        handleAllcatedConfrmCancel()
      }
    };
    const handleAllcatedConfrmCancel=()=>
    {
      setIsAllocatedConfirm(false)
    }

  return (
    <>
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Payment No: {selectedPaymentItem?.paymentNumber || ""}</DialogTitle>
      <PaymentSummary creditAmount={selectedPaymentItem?.balance || 0} paymentAmount={selectedPaymentItem?.amount || 0} />
      <Typography variant="h6" sx={{ px: 3, py: 2 }}>
        List Of Payments
      </Typography>
      <Box
        sx={{
          display: "flex",
          px: 3,
          py: 1,
          fontWeight: "bold",
          borderBottom: "2px solid #ddd",
          backgroundColor: "#fafafa",
        }}
      >
        <Box sx={{ width: "30%" }}>Invoice Number</Box>
        <Box sx={{ width: "30%" }}>Total Amount</Box>
        <Box sx={{ width: "20%" }}>Created Date</Box>
        <Box sx={{ width: "20%" }}>Action</Box>
      </Box>
      <DialogContent dividers sx={{ maxHeight: 400, overflowY: "auto", p: 0 }}>
        {loading ?      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          width: '100%',
                          margin:"10px 0px"
                        }}
                      >
                        <CircularProgress color="success" />
                      </div> :
          <>
            {invoicePayments.length > 0 ? (
              <>
                {invoicePayments.slice(0, visibleCount).map((item, index) => (
                  <Stack
                    key={item.id || index}
                    direction="row"
                    spacing={2}
                    sx={{
                      px: 3,
                      py: 1,
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <Box sx={{ width: "30%" }}>{item.contractNumber.toUpperCase()}</Box>
                    <Box sx={{ width: "30%" }}>{item?.amount || 0}</Box>
                    <Box sx={{ width: "20%" }}>{moment.utc(item?.created).format("DD-MM-YYYY")}</Box>
               <Box sx={{ width: "20%" }}>
  {(item.invoiceId || item.leaseInvoiceId)&& (
<Tooltip
  title={item.amount > 0 ? "Unallocate" : "No amount to unallocate"}
  arrow
>
  <span>
    <IconButton
      size="small"
      onClick={() => showSelectedPayment(item)}
      disabled={item.amount <= 0}
    >
      <BlockIcon />
    </IconButton>
  </span>
</Tooltip>
  )}
</Box>

                  </Stack>
                ))}
                {visibleCount < invoicePayments.length && (
                  <Box sx={{ textAlign: "center", py: 2 }}>
                    <Button
                      variant="outlined"
                      onClick={handleLoadMore}
                      size="small"
                    >
                      Load More
                    </Button>
                  </Box>
                )}
              </>
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ p: 2, textAlign: "center" }}
              >
                No payment details available.
              </Typography>
            )}
          </>
        }
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>

          {isAllocatedConfirm && (
              <ConfirmDialoag
                onCancel={handleAllcatedConfrmCancel}
                onOk={updateInvoicePayment}
                title={"Are You Sure?"}
                children={selectedPaymentId?.contractNumber?.toUpperCase()}
              />
            )}
    </>

  );
};

export default ListPaymentDetails;
